import React from "react";

import { LiveChatWidget } from "@livechat/widget-react";
import { format } from "date-fns";
import { Translation } from "react-i18next";

import { withTrans } from "@components/WithTrans/withTrans";
import { Link } from "@samskip/frontend-components";
type FooterProps = {
  language: string;
};

const Footer: React.FC<FooterProps> = ({ language }) => {
  const links: Record<string, unknown> = {
    is: {
      offices: "https://www.samskip.is/um-samskip/skrifstofur",
      terms:
        "https://www.samskip.is/wp-content/uploads/2026/01/skilmalar_thjonvef_ISL.pdf",
    },
    en: {
      offices: "https://en.samskip.is/about-samskip/offices/",
      terms:
        "https://www.samskip.is/wp-content/uploads/2026/01/skilmalar_thjonvef_ISL.pdf",
    },
  };
  return (
    <Translation>
      {(t) => (
        <footer className="min-h-24 text-neutral-0 bg-primary-500">
          <div className="flex flex-col md:flex-row justify-between xl:container mx-auto px-8 py-2 md:py-4">
            <div className="flex flex-col">
              <p>
                © {format(new Date(), "yyyy")} Samskip hf | Kjalarvogur 7-15 |
                104 Reykjavik | {t("LABEL_ICELAND")}
              </p>
              <p>
                Tel <span className="font-bold">+354 458 8000</span>
              </p>
              <p>
                E-mail{" "}
                <Link
                  className="font-bold"
                  color="neutral-0"
                  href="mailto:customer.service@samskip.com"
                >
                  customer.service@samskip.com
                </Link>
              </p>
            </div>
            <div className="py-2 md:py-0">
              <Link
                color="neutral-0"
                href={links[language || "is"].offices}
                rel="noreferrer"
                target="_blank"
              >
                {t("FOOTER_OFFICEANDAGENTS")}
              </Link>
              <span className="px-2">|</span>
              <Link
                color="neutral-0"
                href={links[language || "is"].terms}
                rel="noreferrer"
                target="_blank"
              >
                {t("FOOTER_TERMS")}
              </Link>
            </div>
          </div>
          <LiveChatWidget license="12450333" />
        </footer>
      )}
    </Translation>
  );
};

export default withTrans(Footer);
